/*
    Uses combineReducers Utility To Combine all The Reducers.
*/

import { combineReducers } from 'redux';
import attachments from './attachments';
import auth from './auth';
import timeline from './timeline';
import userList from './userList';
import userInfo from './userInfo';
import cypressGroupedTest from './cypressGroupedTestReducer';
import lambdaTestBuildData from './lambdaTestBuildDataReducer';
import lambdaTestTestData from './lambdaTestTestDataReducer';
import lambdaTestConfigData from './lambdaTestConfigDataReducer';
import lambdaTestTestDetailHashMap from './lambdaTestTestDetailReducer';
import lambdaTestLiveStreamReducer from './lambdaTestLiveStreamReducer';
import lambdaTestConcurrencyReducer from './lambdaTestConcurrencyReducer';
import newDataNotifier from './newDataNotifier';
import lambdaTestAbortReducer from './lambdaTestAbortReducer';
import lambdaTestPauseReducer from './lambdaTestPauseReducer';
import lambdaTestDeleteReducer from './lambdaTestDeleteReducer';
import lambdaTestPdfReportReducer from './lambdaTestPdfReportReducer';
import lambdaTestShareReducer from './lambdaTestShareReducer';
import filterPersist from './ml2.0/lambdaFilterPersistReducer';
import commandLogs from './ml2.0/commandLogs';
import consoleLogs from './ml2.0/consoleLogs';
import networkLogs from './ml2.0/networkLogs';
import seleniumLogs from './ml2.0/seleniumLogs';
import detailedCypressCommandLogs from './detailedCypressCommandLogs';
import terminalLogs from './ml2.0/terminalLogs';
import deviceLogs from './ml2.0/deviceLogs';
import performanceReport from './ml2.0/performanceReport';
import videoLogsSync from './ml2.0/videoLogsSyncReducer';
import testArchives from './testArchives';
import orgPreferencesReducer from './orgPreferencesReducer';
import rerunTest from './rerunTestReducer';
import { smartUIReducer as smartUIDetails } from '@lt-web-platform/smart-ui';
import testDetailUrl from './ml2.0/testDetailUrlPersistReducer';
import testManager from './ml2.0/testManager';
import accessibilityDetails from './accessibilityReducer';
import lambdaTestSidebarTestListReducer from './lambdaTestSidebarTestListReducer';
import lambdaTestHistoryReducer from './lambdaTestHistoryReducer';
import otherProductConfig from './otherProductConfigReducer';
import playwrightTraceLogs from './ml2.0/playwrightTraceLogs';

export default combineReducers({
  auth,
  accessibilityDetails,
  attachments,
  cypressGroupedTest,
  timeline,
  userList,
  userInfo,
  lambdaTestBuildData,
  lambdaTestTestData,
  lambdaTestConfigData,
  lambdaTestTestDetailHashMap,
  lambdaTestLiveStreamReducer,
  lambdaTestConcurrencyReducer,
  newDataNotifier,
  lambdaTestAbortReducer,
  lambdaTestDeleteReducer,
  lambdaTestPauseReducer,
  lambdaTestPdfReportReducer,
  lambdaTestShareReducer,
  lambdaTestSidebarTestListReducer,
  lambdaTestHistoryReducer,
  filterPersist,
  commandLogs,
  consoleLogs,
  networkLogs,
  seleniumLogs,
  smartUIDetails,
  terminalLogs,
  deviceLogs,
  testManager,
  performanceReport,
  videoLogsSync,
  rerunTest,
  testArchives,
  testDetailUrl,
  orgPreferencesReducer,
  detailedCypressCommandLogs,
  otherProductConfig,
  playwrightTraceLogs
});
